"use strict";
import { create } from "zustand";
import { devtools } from "zustand/middleware";
export const useTransactionResponse = create()(
  devtools(
    (set) => ({
      transactionResponse: void 0,
      setTransactionResponse: (txResponse) => set(() => ({
        transactionResponse: txResponse
      }))
    }),
    { name: "useTransactionResponse" }
  )
);
